// extracted by mini-css-extract-plugin
export default {"ResponderStaff":"responderStaff_ResponderStaff__YCkLJ","Table":"responderStaff_Table__mHuek","Name":"responderStaff_Name__nMZtA","Role":"responderStaff_Role__iuQ8H"};